module.exports = __webpack_public_path__ + "static/img/kyc-icon.4e1a54bd.gif";